/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Answer_Every_QuestionInputs */

const en_us2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer every question to continue.`)
};

const pt_br2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda todas as perguntas para continuar.`)
};

const es_419_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde todas las preguntas para continuar.`)
};

const pt_pt2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde a todas as perguntas para continuar.`)
};

const fr_fr2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponds à toutes les questions pour continuer.`)
};

const de_de2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte alle Fragen, um fortzufahren.`)
};

const it_it2_chat_answer_every_question = /** @type {(inputs: Chat_Answer_Every_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi a tutte le domande per continuare.`)
};

/**
* | output |
* | --- |
* | "Answer every question to continue." |
*
* @param {Chat_Answer_Every_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_answer_every_question = /** @type {((inputs?: Chat_Answer_Every_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Answer_Every_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_answer_every_question(inputs)
	if (locale === "es-419") return es_419_chat_answer_every_question(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_answer_every_question(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_answer_every_question(inputs)
	if (locale === "de-DE") return de_de2_chat_answer_every_question(inputs)
	if (locale === "it-IT") return it_it2_chat_answer_every_question(inputs)
	return en_us2_chat_answer_every_question(inputs)
});
export { chat_answer_every_question as "chat.answer_every_question" }